/* eslint-disable arrow-body-style */
/* eslint-disable react-hooks/rules-of-hooks */

import React from 'react';
import classnames from 'classnames';
import GPSelect from '@gp/components/Select';
import GPSelectMultiple from '@gp/components/SelectMultiple';
import { Bubble } from '@home/components/TeaComponents';
import RangePicker, { IGPRangePickerProps } from '@gp/components/RangePicker';
import ComposedDatePicker from '@gp/components/ComposedDatePicker';
import CascadeProject from '@gp/components/CascadeProject';

import type {
  IDynamicSelectFilterControlWithValueAccessor,
  IDynamicSelectMultipleFilterControlWithValueAccessor,
  IDynamicComposedFilterControlWithValueAccessor,
} from '../types';

const OVERLAY_CLASSNAME = 'dbg-dynamic-filter__select-overlay';
const BOX_CLASSNAME = 'globalpedia-custom-scrollbar globalpedia-modal-font14';

const renderRangePicker = (props: IGPRangePickerProps) => {
  const { startOfWeek = 7, value } = props;
  const { dateType } = value || {};
  return <RangePicker {...props} startOfWeek={startOfWeek} type={dateType} />;
};

const renderSelect = (props: IDynamicSelectFilterControlWithValueAccessor) => {
  const { className, overlayClassName, boxClassName, ...restProps } = props;

  return (
    <GPSelect
      {...restProps}
      className={classnames('dbg-dynamic-filter-select', className)}
      overlayClassName={classnames(
        'dbg-dynamic-filter-overlay',
        OVERLAY_CLASSNAME,
        overlayClassName,
      )}
      boxClassName={classnames('dbg-dynamic-filter-box', BOX_CLASSNAME, boxClassName)}
    />
  );
};

const renderSelectMultiple = (props: IDynamicSelectMultipleFilterControlWithValueAccessor) => {
  const { className, overlayClassName, boxClassName, bubbleProps, ...restProps } = props;
  const {
    style: bubbleStyle,
    overlayStyle: bubbleOverlayStyle,
    className: bubbleClassName,
    dark = true,
    flipped = false,
    escapeWithReference = true,
    arrowPointAtCenter = true,
    ...restBubbleProps
  } = bubbleProps || {};

  const { maxWidth: bubbleStyleMaxWidth = 450 } = bubbleStyle || {};
  const { zIndex: bubbleOverlayStyleZIndex = 1 } = bubbleOverlayStyle || {};

  return (
    <Bubble
      {...restBubbleProps}
      style={{ ...bubbleStyle, maxWidth: bubbleStyleMaxWidth }}
      overlayStyle={{ ...bubbleOverlayStyle, zIndex: bubbleOverlayStyleZIndex }}
      className={classnames('dbg-bubble-max-width', bubbleClassName)}
      dark={dark}
      flipped={flipped}
      escapeWithReference={escapeWithReference}
      arrowPointAtCenter={arrowPointAtCenter}
    >
      <GPSelectMultiple
        {...restProps}
        className={classnames('dbg-dynamic-filter-select-multiple', className)}
        overlayClassName={classnames(
          'dbg-dynamic-filter-overlay',
          OVERLAY_CLASSNAME,
          overlayClassName,
        )}
        boxClassName={classnames('dbg-dynamic-filter-box', BOX_CLASSNAME, boxClassName)}
      />
    </Bubble>
  );
};

const renderComposedDatePicker = (props: IDynamicComposedFilterControlWithValueAccessor) => {
  const { ...restProps } = props;

  return <ComposedDatePicker {...restProps} />;
};

const renderCascadeProject = (props: IDynamicComposedFilterControlWithValueAccessor) => {
  const { ...restProps } = props;

  return <CascadeProject {...restProps} />;
};

export const CONTROL_RENDERERS: {
  rangePicker: (props: IGPRangePickerProps) => React.ReactElement;
  select: (props: IDynamicSelectFilterControlWithValueAccessor) => React.ReactElement;
  selectMultiple: (
    props: IDynamicSelectMultipleFilterControlWithValueAccessor,
  ) => React.ReactElement;
  composedDatePicker: (props: IDynamicComposedFilterControlWithValueAccessor) => React.ReactElement;
  cascadeProject: (props: IDynamicComposedFilterControlWithValueAccessor) => React.ReactElement;
} = {
  rangePicker: renderRangePicker,
  select: renderSelect,
  selectMultiple: renderSelectMultiple,
  composedDatePicker: renderComposedDatePicker,
  cascadeProject: renderCascadeProject,
};
